import { useEffect, useRef, useState } from 'react'
import { connected, withErrorBoundary, Spinner, Formatter, GradientedScroller } from 'shared'
import { EventApi, Park, ParkApi, User, HighlightApi } from 'api'
import { MissingImage } from 'customizations'
import { TopLevelPage } from 'ui'
import EventCard from './EventCardHomeFeed'
import ParkCard from '../parks/ParkCard'
import { SmartButtonStub } from "ui/smart-buttons";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

HomeFeed = ({ match }) ->
  [highlights, setHighlights] = useState([])
  [lifestyleEvents, setLifestyleEvents] = useState([])
  [lifestylePlaces, setLifestylePlaces] = useState([])
  [lifestyleSelected, setLifestyleSelected] = useState()
  [lifestyles, setLifestyles] = useState([])
  [secondaryHighlights, setSecondaryHighlights] = useState([])

  isMobile = window.innerWidth < 576
  eventsSliderRef = useRef(null)
  feedItemId = match.params.id
  groups = EventApi.kick('mineGrouped')
  placesSliderRef = useRef(null)

  useEffect ->
    HighlightApi.primaryHighlights()
      .then (fetchedHighlights) ->
        setHighlights(fetchedHighlights)
      .catch (error) ->
        console.error("Failed to fetch primary highlights:", error)

    HighlightApi.primaryLifestyles()
      .then (fetchedLifestyles) ->
        setLifestyles(fetchedLifestyles)
        lifestyleClicked(fetchedLifestyles[0])
        console.log("Lifestyles", fetchedLifestyles)
      .catch (error) ->
        console.error("Failed to fetch primary highlights:", error)

    HighlightApi.secondaryHighlights()
      .then (fetchedSecondaryHighlights) ->
        setSecondaryHighlights(fetchedSecondaryHighlights)
      .catch (error) ->
        console.error("Failed to fetch secondary highlights:", error)

    undefined
  , []

  lifestyleClicked = (lifestyle) ->
    tagIds = lifestyle.place_id.filter((tag_id) => !_.isEmpty(tag_id))
    setLifestyleSelected(lifestyle)
    EventApi.all({ tag_ids: tagIds }).then (data) =>
      setLifestyleEvents(data.events)
      eventsSliderRef.current?.slickGoTo(0)
    ParkApi.index({ tag_ids: tagIds }).then (data) =>
      shuffled = data.sort(() => Math.random() - 0.5)
      setLifestylePlaces(shuffled)
      placesSliderRef.current?.slickGoTo(0)

  renderHeroImageSection = ->
    <div className="px-3 mb-5">
      <div className={'SectionHero position-relative'} data-nc-id="SectionHero">
        <div className="headingSection position-absolute text-center d-flex flex-column align-items-center w-100">
          <span className="homeFeedSubText font-weight-bold d-block" style={{ color: User.homeFeedSubTextColour || 'inherit' }} >
            <span dangerouslySetInnerHTML={{__html: Formatter.simpleFormat User.homeFeedSubText}}></span>
          </span>
          <h1
            className="homeFeedHeader font-weight-bold"
            style={{ color: User.homeFeedHeaderColour || 'inherit' }}
          >
            {
              if User.homeFeedHeader and User.homeFeedHeader.trim() != ''
                User.homeFeedHeader
              else
                <span className="visually-hidden">Home Feed</span>
            }
          </h1>
        </div>

        <div className="position-relative homeFeedBanner">
          {
            if User.homeFeedBanner
              if User.homeFeedBanner.endsWith('.mp4') or User.homeFeedBanner.endsWith('.webm')
                <video
                  className="position-absolute w-100 h-80 object-fit-cover homeFeedPicture"
                  src={User.homeFeedBanner}
                  autoPlay={true}
                  loop={true}
                  muted={true}
                  controls={false}
                />
              else
                <img
                  className="position-absolute w-100 h-80 object-fit-cover homeFeedPicture"
                  src={User.homeFeedBanner}
                  alt="hero"
                />
            else
              <div className="position-absolute w-100 h-80 object-fit-cover"></div>
          }
        </div>
      </div>
    </div>

  renderHighlights = ->
    if highlights?.length
      <div className="row mb-md-5 pb-md-5">
        <div key={0} className="col-12 col-md-4 col-sm-6 col-lg-4 d-flex mb-3">
          <CardCategory index={0} name={highlights[0]?.name} image={highlights[0]?.image} crop={highlights[0]?.crop} place={highlights[0]?.place} type={highlights[0]?.type} place_id={highlights[0]?.place_id} text_color={highlights[0]?.text_color} />
        </div>
        <div key={1} className="col-12 col-sm-6 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-12 mb-3">
              <CardCategory index={1} name={highlights[1]?.name} image={highlights[1]?.image} crop={highlights[1]?.crop} place={highlights[1]?.place} type={highlights[1]?.type} place_id={highlights[1]?.place_id} text_color={highlights[1]?.text_color} />
            </div>
            <div className="col-12 mb-3">
              <CardCategory index={2} name={highlights[2]?.name} image={highlights[2]?.image} crop={highlights[2]?.crop} place={highlights[2]?.place} type={highlights[2]?.type} place_id={highlights[2]?.place_id} text_color={highlights[2]?.text_color} />
            </div>
          </div>
        </div>
        <div key={2} className="col-12 col-sm-6 col-md-4 col-lg-4 d-flex mb-3">
          <CardCategory index={3} name={highlights[3]?.name} image={highlights[3]?.image} crop={highlights[3]?.crop} place={highlights[3]?.place} type={highlights[3]?.type} place_id={highlights[3]?.place_id} text_color={highlights[3]?.text_color} />
        </div>
      </div>

  renderHighlightsSecondary = ->
    if secondaryHighlights.length
      <div className="nc-SectionGridCategoryBox position-relative">
        <div className={'nc-Section-Heading position-relative d-flex flex-column text-center align-items-center mb-md-5'}>
          <div className={'w-100 max-w-50 mx-auto'}>
            <h2 className="h2 font-weight-bold custom-heading-community">
              Discover Community Happenings and Amenities
            </h2>
          </div>
        </div>

        <div className="row justify-content-center">
          { secondaryHighlights.map((highlight, i) => (
            <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4" key={i}>
              { renderSecondaryHighlight(highlight) }
            </div>
          ))}
        </div>
      </div>

  secondaryHighlightImageStyle = (crop) ->
    base =
      width: '100%'
      height: '100%'
      objectFit: 'cover'
    return base unless crop?
    x = parseFloat(crop.x)
    y = parseFloat(crop.y)
    w = parseFloat(crop.w)
    h = parseFloat(crop.h)
    return base unless isFinite(x) && isFinite(y) && isFinite(w) && isFinite(h)
    return base unless w > 0 && h > 0 && w <= 1 && h <= 1

    {
      position: 'absolute'
      top: 0
      left: 0
      maxWidth: 'none'
      width: "#{100 / w}%"
      height: 'auto'
      transformOrigin: 'top left'
      transform: "translate(-#{x * 100}%, -#{y * 100}%)"
    }

  renderSecondaryHighlight = (highlight) ->
    place = highlight?.place
    return null unless place?

    image = highlight?.image || place.image_preview_url || MissingImage
    name = highlight?.name || place.name
    crop = highlight?.crop
    imgStyle = secondaryHighlightImageStyle(crop)

    handleClick = (e) ->
      if highlight?.type == "menu" && highlight?.place_id
        e.preventDefault()
        window.location.href = "/app#/menu/#{highlight.place_id}"

    linkPath = "home/#{place?.uid}"

    <Link
      to={linkPath}
      onClick={handleClick}
      className="nc-CardCategoryBox1 d-flex align-items-center p-3 rounded shadow-sm rounded"
      data-nc-id="CardCategoryBox1"
    >
      <div
        className="flex-shrink-0 rounded-circle overflow-hidden position-relative"
        style={{ width: '96px', height: '96px' }}
      >
        <img
          src={image}
          className="img-fluid"
          style={imgStyle}
          alt={
            if name
              "#{name} image"
            else
              "Highlight image"
          }
        />
      </div>
      <div className="ml-3 flex-grow-1">
        <h2 className="h5 font-weight-medium mb-1 text-truncate fontColour custom-text-community">
          {name}
        </h2>
      </div>
    </Link>

  renderLifestyleEvents = ->
    <div className="row">
      <div className="upcoming-events-container lifestyle-events col-12 mt-0">
        <h4 className="mb-3 text-muted custom-text-community"> Explore Matching Events </h4>
        <Slider ref={eventsSliderRef} { ...sharedSliderProps() }>
          {
            lifestyleEvents.map (event, index) =>
              <div className="pr-2 feed-column-body mb-3">
                <EventCard event={event} key={event.uid} base='home' />
              </div>
          }
        </Slider>
      </div>
    </div>

  renderLifestyleExplorer = ->
    if lifestyles?.length && User.current && User.current.isGuestExperience
      <div className="lifestyle-explorer">
        <div className="row justify-content-center parks-header-container">
          <div className="col-md-12">
            <h1 className="upcoming-events-header font-weight-bold custom-heading-community">Lifestyle Explorer</h1>
            <div className="row mb-5 lifestyles">
              {
                lifestyles.map (lifestyle) =>
                  <div className="lifestyle-card col-12 col-md-3" onClick={() => lifestyleClicked(lifestyle)}>
                    <div className="nc-CardCategoryBox1 d-flex align-items-center p-3 rounded shadow-sm rounded #{if lifestyle.name == lifestyleSelected?.name then 'active'}">
                      <div className="flex-shrink-0 rounded-circle overflow-hidden" style={{ width: '96px', height: '96px' }}>
                        <img src={ lifestyle.image || MissingImage } className="img-fluid" style={{ height: '96px' }} alt={
                            if lifestyle?.id
                              "#{lifestyle.name} (ID: #{lifestyle.id})"
                            else
                              "#{lifestyle.name}"
                          } />
                      </div>
                      <div className="ml-3 flex-grow-1">
                        <h2 className="h5 font-weight-medium mb-1 text-truncate fontColour custom-text-community">
                          { lifestyle.name }
                        </h2>
                      </div>
                    </div>
                  </div>
              }
            </div>
            { renderLifestyleEvents() }
            { renderLifestylePlaces() }
          </div>
        </div>
      </div>

  renderLifestylePlaces = ->
    <div className="row">
      <div className="CustomMenu lifestyle-parks col-12 mt-5">
        <h4 className="mb-3 text-muted custom-text-community"> Explore Matching Amenities </h4>
        <Slider ref={placesSliderRef} { ...sharedSliderProps() }>
          {
            lifestylePlaces.map (place, index) =>
              <div className="pr-2 mb-3">
                <ParkCard park={place} key={place.uid} base='home' />
              </div>
          }
          </Slider>
      </div>
    </div>

  renderUpcomingEvents = ->
    if User.current && !User.current.isGuestExperience
      if _.isEmpty(groups)
        null
      else
        <div className="upcoming-events-container">
          <div className="row justify-content-center parks-header-container">
            <div className="col-md-8">
              <h1 className="upcoming-events-header custom-heading-community">Upcoming Events For You</h1>
            </div>
          </div>
          <GradientedScroller containerClassName="feed-columns row">
            {
              for date in Object.keys(groups).sort()
                <section className="feed-column col-sm-4 col-lg-4 col-xl-3" key={date}>
                  <header className="feed-column-header custom-text-community">
                    <b>{Formatter.dateToWeekDay(date, {format: 'full'})}</b>
                    <time dateTime={date}>{Formatter.date(date, 'usDateYYYY')}</time>
                    <div className="feed-column-border">
                      <span className="feed-column-circle"></span>
                      <span className="feed-column-line"></span>
                    </div>
                  </header>
                  <div className="feed-column-body">
                    {
                      for model in groups[date]
                        if model instanceof Park
                          <ParkCard park={model} key={model.uid} base='home' />
                        else
                          <EventCard event={model} key={model.uid} base='home' />
                    }
                  </div>
                </section>
            }
          </GradientedScroller>
        </div>

  sharedSliderProps = ->
    slideLimit = if isMobile then 1 else 4
    { dots: true, infinite: false, slidesToShow: slideLimit, slidesToScroll: slideLimit, arrows: false }

  return <Spinner /> unless groups

  <TopLevelPage className="HomeFeed" fullWidth={true} modelId={feedItemId} base="/home">
    <div className="HomeFeedInner">
      <div> { renderHeroImageSection() } </div>
      <div className="container-fluid">
        { renderHighlightsSecondary() }
        { renderHighlights() }
        { renderUpcomingEvents() }
        { renderLifestyleExplorer() }
      </div>
    </div>
  </TopLevelPage>


highlightImageStyle = (crop, natural, frame) ->
  return null unless crop?

  x = parseFloat(crop.x)
  y = parseFloat(crop.y)
  w = parseFloat(crop.w)
  h = parseFloat(crop.h)
  return null unless isFinite(x) && isFinite(y) && isFinite(w) && isFinite(h)
  return null unless w > 0 && h > 0 && w <= 1 && h <= 1

  focusX = (x + w / 2) * 100
  focusY = (y + h / 2) * 100
  fallbackStyle =
    objectPosition: "#{focusX}% #{focusY}%"

  return fallbackStyle unless natural? && frame?
  return fallbackStyle unless natural.width > 0 && natural.height > 0 && frame.width > 0 && frame.height > 0

  cropWidth = natural.width * w
  cropHeight = natural.height * h
  scale = Math.max(frame.width / cropWidth, frame.height / cropHeight) * 0.998
  scaledCropWidth = cropWidth * scale
  scaledCropHeight = cropHeight * scale
  left = ((frame.width - scaledCropWidth) / 2) - (x * natural.width * scale)
  top = ((frame.height - scaledCropHeight) / 2) - (y * natural.height * scale)

  {
    position: 'absolute'
    top: 0
    left: 0
    maxWidth: 'none'
    width: "#{natural.width * scale}px"
    height: "#{natural.height * scale}px"
    transformOrigin: 'top left'
    transform: "translate(#{left}px, #{top}px)"
  }

HighlightImage = ({ image, crop, name }) ->
  frameRef = useRef(null)
  [natural, setNatural] = useState(null)
  [frame, setFrame] = useState(null)

  updateFrame = ->
    return unless frameRef.current?
    rect = frameRef.current.getBoundingClientRect()
    return unless rect.width > 0 && rect.height > 0
    setFrame(
      width: rect.width
      height: rect.height
    )

  useEffect ->
    updateFrame()

    resizeObserver = null
    if window.ResizeObserver? && frameRef.current?
      resizeObserver = new ResizeObserver(-> updateFrame())
      resizeObserver.observe(frameRef.current)
    else
      window.addEventListener('resize', updateFrame)

    ->
      resizeObserver?.disconnect()
      window.removeEventListener('resize', updateFrame)
  , []

  handleLoad = (e) ->
    img = e.currentTarget
    setNatural(
      width: img.naturalWidth
      height: img.naturalHeight
    )
    updateFrame()

  imgStyle = highlightImageStyle(crop, natural, frame)

  <>
    <div ref={frameRef} className="highlight-crop-frame w-100"></div>
    <img
      src={image || MissingImage}
      className="highlight-cropped-image position-absolute"
      onLoad={handleLoad}
      style={imgStyle || {}}
      alt={
        if name?
          "#{name} image"
        else
          "Background image"
      }
    />
  </>

CardCategory = ({ name, image, place, type, place_id, text_color, crop, index }) ->
  handleClick = (e) ->
    if type == "menu" && place_id
      e.preventDefault()
      window.location.href = "/app#/menu/#{place_id}"

  linkPath = "home/#{place?.uid}"
  <Link
    to={ linkPath }
    onClick={handleClick}
    className='nc-CardCategory position-relative d-flex w-100 group overflow-hidden '
    data-nc-id="CardCategory"
  >
    <HighlightImage image={image} crop={crop} name={name} />
    <div className="position-absolute fixed-bottom p-3 p-sm-4 text-white">
      <span className="position-absolute w-100 h-100 bg-dark-gradient"></span>
      <h2
        className="position-relative text-lg font-weight-bolder highlights-information"
        style={{ color: text_color || 'black' }}
      >
        { name }
      </h2>
    </div>
  </Link>

export default withErrorBoundary connected HomeFeed
